import React, { createContext, useContext, useEffect, useRef } from 'react';

const ThemeContext = createContext({ progress: 0 });

// Blue Glacier (0%) → Lava (100%)
function getThemeHue(progress) {
  if (progress <= 0) return 220;
  if (progress >= 100) return 14;
  if (progress <= 25) return 220 - (progress / 25) * 40;
  if (progress <= 50) return 180 - ((progress - 25) / 25) * 140;
  if (progress <= 75) return 40 - ((progress - 50) / 25) * 16;
  return 24 - ((progress - 75) / 25) * 10;
}

export function ThemeProvider({ children, workoutProgress, workoutStarted, todayCompleted }) {
  const flashRef = useRef(null);
  const prevProgress = useRef(0);
  const effectiveProgress = todayCompleted ? 100 : (workoutStarted ? workoutProgress : 0);

  useEffect(() => {
    const hue = getThemeHue(effectiveProgress);
    const root = document.documentElement;
    root.style.setProperty('--theme-hue', String(Math.round(hue)));
    root.style.setProperty('--theme-sat', '100%');
    root.style.setProperty('--theme-lit', '52%');

    // Flash on big jumps
    if (effectiveProgress - prevProgress.current >= 12 && flashRef.current) {
      flashRef.current.classList.remove('theme-flash');
      void flashRef.current.offsetWidth;
      flashRef.current.classList.add('theme-flash');
    }
    prevProgress.current = effectiveProgress;
  }, [effectiveProgress]);

  return (
    <ThemeContext.Provider value={{ progress: effectiveProgress }}>
      <div
        ref={flashRef}
        className="fixed inset-0 pointer-events-none z-[9999]"
        style={{ background: `radial-gradient(ellipse at 50% 80%, var(--theme-glow-strong), transparent 60%)`, opacity: 0 }}
      />
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
